<div>
    <div class="border-b border-gray-200 mb-4 pb-3">
        <app-list-header title="My documents" subTitle="Everything you've signed or sent for signature.">
        </app-list-header>
    </div>
    <div class="flex items-center gap-1 mb-4 flex-wrap">
        <button class="tab-btn" [ngClass]="activeTab === 'signed' ? 'tab-btn--active' : ''" (click)="setTab('signed')">
            Signed <span class="tab-count">{{ signedTotalCount }}</span>
        </button>
        <button class="tab-btn" [ngClass]="activeTab === 'pending' ? 'tab-btn--active' : ''"
            (click)="setTab('pending')">
            Pending <span class="tab-count">{{ pendingTotalCount }}</span>
        </button>
    </div>
    <ng-container *ngIf="activeTab === 'signed'">
        <div class="hidden md:flex items-center w-full px-6 py-2 mb-1">
            <span class="w-[35%] text-xs font-light text-gray-400 uppercase tracking-wide">Document</span>
            <span class="w-[20%] text-xs font-light text-gray-400 uppercase tracking-wide">Signatory</span>
            <span class="w-[20%] text-xs font-light text-gray-400 uppercase tracking-wide">Date</span>
            <span class="w-[10%] text-xs font-light text-gray-400 uppercase tracking-wide">Status</span>
            <span class="w-[10%] text-xs font-light text-gray-400 uppercase tracking-wide">Credits Used</span>
            <span class="w-[10%] text-xs font-light text-gray-400 uppercase tracking-wide">Actions</span>
        </div>
        <div class="flex flex-col gap-2 mt-2" *ngIf="!loadSignedRecords && !signedErrorMessage">
            <div *ngFor="let doc of signedDocs" class="bg-white rounded-[10px] border border-[rgba(201,206,211,0.6)] shadow-sm
                       hover:border-[#de7141] hover:bg-gray-50 transition-all duration-150
                       flex flex-col md:flex-row md:items-center
                       px-4 md:px-6 py-4 md:py-0 md:min-h-[60px] gap-3 md:gap-0">
                <div class="flex items-center gap-2 md:w-[35%]">
                    <div class="doc-icon shrink-0">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1b295c" stroke-width="2">
                            <rect x="4" y="2" width="16" height="20" rx="2"></rect>
                            <path d="M9 12h6M9 16h4M14 2v4h4"></path>
                        </svg>
                    </div>
                    <div class="flex flex-col min-w-0">
                        <p class="m-0 text-sm font-semibold text-[#1b295c] leading-snug truncate">
                            {{ doc?.documentName || doc?.fileName || '—' }}
                        </p>
                        <p class="m-0 text-[11px] text-gray-400">
                            {{ doc?.isSelf ? 'Self-signed' : 'Shared Document' }}
                        </p>
                    </div>
                </div>
                <div class="flex items-center gap-2 md:w-[20%]">
                    <span class="text-xs text-gray-400 font-semibold uppercase tracking-wide md:hidden w-24 shrink-0">
                        Signatory
                    </span>
                    <div class="flex items-center gap-1 min-w-0">
                        <span class="text-sm text-gray-700 truncate">{{ doc?.signatories?.[0]?.name || doc?.signatories?.[0]?.email || '—' }}</span>
                    </div>
                </div>
                <div class="flex items-center gap-2 md:w-[20%]">
                    <span class="text-xs text-gray-400 font-semibold uppercase tracking-wide md:hidden w-24 shrink-0">
                        Date
                    </span>
                    <span class="text-sm text-gray-600">{{ doc?.created | date: 'dd MMM yy, hh:mm a' }}</span>
                </div>
                <div class="flex items-center gap-2 md:w-[10%]">
                    <span class="text-xs text-gray-400 font-semibold uppercase tracking-wide md:hidden w-24 shrink-0">
                        Status
                    </span>
                    <span class="status-badge status-badge--signed">
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="3">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        Signed
                    </span>
                </div>
                <div class="flex items-center gap-2 md:w-[10%]">
                    <span class="text-xs text-gray-400 font-semibold uppercase tracking-wide md:hidden w-24 shrink-0">
                        Credits
                    </span>
                    <span class="credit-pill">{{ doc?.esignCredits ?? '—' }}</span>
                </div>
                <div class="flex items-center gap-2 md:w-[10%]">
                    <span class="text-xs text-gray-400 font-semibold uppercase tracking-wide md:hidden w-24 shrink-0">
                        Actions
                    </span>
                    <div *ngIf="doc?.actionType === 'eSign-success' || doc?.actionType === 'document-shared'"
                        [ngbTooltip]="'View Document'" tooltipClass="custom-tooltip"
                        class="btn btn-sm b-btn view-doc-btn" (click)="openDocumentModal(doc)">
                        <app-common-icon [faIcon]="faEye" [loadingIcon]="loadingDocId === doc?._id"></app-common-icon>
                    </div>
                </div>
            </div>
            <div *ngIf="!signedDocs.length" class="bg-white rounded-[10px] border border-[rgba(201,206,211,0.6)] px-6 py-8
                       flex items-center justify-center text-sm text-gray-400">
                No signed documents found.
            </div>
        </div>
        <div *ngIf="loadSignedRecords" class="bg-white rounded-[10px] border border-[rgba(201,206,211,0.6)] px-6 py-8
                   flex items-center justify-center text-danger">
            <app-common-icon [loadingIcon]="loadSignedRecords"></app-common-icon>
        </div>
        <div *ngIf="signedErrorMessage" class="bg-white rounded-[10px] border border-[rgba(201,206,211,0.6)] px-6 py-8
                   flex items-center justify-center text-sm text-danger text-center">
            {{ signedErrorMessage }}
        </div>

        <div *ngIf="signedCountErrorMessage"
            class="text-center text-danger text-sm mt-3 bg-red-50 py-2 border border-red-100 rounded">
            <p>{{ signedCountErrorMessage }}</p>
        </div>
        <div class="footer-page-ination">
            <app-paginator [totalCount]="signedTotalCount" (selectedPage)="onSignedPageChange($event)"></app-paginator>
        </div>
    </ng-container>
    <ng-container *ngIf="activeTab === 'pending'">
        <div class="hidden md:flex items-center w-full px-6 py-2 mb-1">
            <span class="w-[30%] text-xs font-light text-gray-400 uppercase tracking-wide">Document</span>
            <span class="w-[18%] text-xs font-light text-gray-400 uppercase tracking-wide">Shared By</span>
            <span class="w-[18%] text-xs font-light text-gray-400 uppercase tracking-wide">Signatory</span>
            <span class="w-[16%] text-xs font-light text-gray-400 uppercase tracking-wide">Date</span>
            <span class="w-[10%] text-xs font-light text-gray-400 uppercase tracking-wide">Status</span>
            <span class="w-[8%] text-xs font-light text-gray-400 uppercase tracking-wide">Actions</span>
        </div>
        <div class="flex flex-col gap-2 mt-2" *ngIf="!loadPendingRecords && !pendingErrorMessage">
            <div *ngFor="let doc of pendingDocs" class="bg-white rounded-[10px] border border-[rgba(201,206,211,0.6)] shadow-sm
                       hover:border-[#de7141] hover:bg-gray-50 transition-all duration-150
                       flex flex-col md:flex-row md:items-center
                       px-4 md:px-6 py-4 md:py-0 md:min-h-[60px] gap-3 md:gap-0">
                <div class="flex items-center gap-2 md:w-[30%]">
                    <div class="doc-icon shrink-0">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1b295c" stroke-width="2">
                            <rect x="4" y="2" width="16" height="20" rx="2"></rect>
                            <path d="M9 12h6M9 16h4M14 2v4h4"></path>
                        </svg>
                    </div>
                    <div class="flex flex-col min-w-0">
                        <p class="m-0 text-sm font-semibold text-[#1b295c] leading-snug truncate">
                            {{ doc?.documentName || doc?.fileName || '—' }}
                        </p>
                        <p class="m-0 text-[11px] text-gray-400">
                            {{ doc?.signingProgress
                            ? (doc.signingProgress.signed + ' of ' + doc.signingProgress.total + ' signed')
                            : 'Awaiting signature' }}
                        </p>
                    </div>
                </div>
                <div class="flex items-center gap-2 md:w-[18%]">
                    <span class="text-xs text-gray-400 font-semibold uppercase tracking-wide md:hidden w-24 shrink-0">
                        Shared By
                    </span>
                    <span class="text-sm text-gray-700 truncate">{{ doc?.sharedBy?.emailAddress || '—' }}</span>
                </div>
                <div class="flex items-center gap-2 md:w-[18%]">
                    <span class="text-xs text-gray-400 font-semibold uppercase tracking-wide md:hidden w-24 shrink-0">
                        Signatory
                    </span>
                    <div class="flex items-center gap-1 min-w-0">
                        <span class="text-sm text-gray-700 truncate">{{ doc?.recipientEmails?.[0] || '—' }}</span>
                        <div class="tooltip-wrapper" *ngIf="doc?.recipientEmails?.length > 1">
                            <span class="more-badge">+{{ doc?.recipientEmails?.length - 1 }} More</span>
                            <div class="email-tooltip">
                                <div class="tooltip-title">Recipients ({{ doc?.recipientEmails?.length }})</div>
                                <div class="email-item" *ngFor="let email of doc?.recipientEmails">{{ email }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex items-center gap-2 md:w-[16%]">
                    <span class="text-xs text-gray-400 font-semibold uppercase tracking-wide md:hidden w-24 shrink-0">
                        Date
                    </span>
                    <span class="text-sm text-gray-600">{{ doc?.created | date: 'dd MMM yy, hh:mm a' }}</span>
                </div>
                <div class="flex items-center gap-2 md:w-[10%]">
                    <span class="text-xs text-gray-400 font-semibold uppercase tracking-wide md:hidden w-24 shrink-0">
                        Status
                    </span>
                    <span class="status-badge status-badge--pending">
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.5">
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                        {{ getStatus(doc?.status) }}
                    </span>
                </div>
                <div class="flex items-center gap-2 md:w-[8%]">
                    <span class="text-xs text-gray-400 font-semibold uppercase tracking-wide md:hidden w-24 shrink-0">
                        Actions
                    </span>
                    <div class="flex items-center gap-2">
                        <div *ngIf="doc?.lastSignedDocUrl" [ngbTooltip]="'View Document'" tooltipClass="custom-tooltip"
                            class="btn btn-sm b-btn view-doc-btn" (click)="openPendingDocumentModal(doc)">
                            <app-common-icon [faIcon]="faEye"></app-common-icon>
                        </div>
                        <ng-container *ngIf="!isOwner(doc)">
                            <div [ngbTooltip]="'eSign Document'" tooltipClass="custom-tooltip"
                                class="btn btn-sm b-btn view-doc-btn" [class.disabled]="loadPendingRecords"
                                (click)="!loadPendingRecords && openEsignOverlayForPending(doc)">
                                <app-common-icon [faIcon]="faSignature"></app-common-icon>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="isOwner(doc)">
                            <button class="track-link" (click)="openTrackModal(doc)">
                                Track <span class="track-link__arrow">›</span>
                            </button>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div *ngIf="!pendingDocs.length" class="bg-white rounded-[10px] border border-[rgba(201,206,211,0.6)] px-6 py-8
                       flex items-center justify-center text-sm text-gray-400">
                No pending documents found.
            </div>
        </div>
        <div *ngIf="loadPendingRecords" class="bg-white rounded-[10px] border border-[rgba(201,206,211,0.6)] px-6 py-8
                   flex items-center justify-center text-danger">
            <app-common-icon [loadingIcon]="loadPendingRecords"></app-common-icon>
        </div>
        <div *ngIf="pendingErrorMessage" class="bg-white rounded-[10px] border border-[rgba(201,206,211,0.6)] px-6 py-8
                   flex items-center justify-center text-sm text-danger text-center">
            {{ pendingErrorMessage }}
        </div>
        <div *ngIf="pendingCountErrorMessage"
            class="text-center text-danger text-sm mt-3 bg-red-50 py-2 border border-red-100 rounded">
            <p>{{ pendingCountErrorMessage }}</p>
        </div>
        <div class="footer-page-ination">
            <app-paginator [totalCount]="pendingTotalCount"
                (selectedPage)="onPendingPageChange($event)"></app-paginator>
        </div>
    </ng-container>
    <app-success-toaster *ngIf="showSuccessToaster" [title]="successMessage"
        (closeToaster)="closeToaster('success')"></app-success-toaster>
    <app-error-toaster *ngIf="showErrorToaster" [title]="errorMessage"
        (closeToaster)="closeToaster('error')"></app-error-toaster>
</div>
<app-add-credits-modal [isOpen]="showAddCreditsModal" (closeModal)="showAddCreditsModal = false">
</app-add-credits-modal>
<div *ngIf="showTrackModal" class="acm-backdrop" (click)="closeTrackModal()" aria-modal="true" role="dialog">
    <div class="acm-card" (click)="$event.stopPropagation()">
        <div class="acm-header">
            <div class="acm-header__left">
                <div class="acm-header__icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#de7141" stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                </div>
                <div>
                    <h6 class="acm-header__title">Signing Status</h6>
                    <p class="acm-header__sub">{{ trackDoc?.documentName || trackDoc?.fileName || 'Document' }}</p>
                </div>
            </div>
            <button class="acm-close" (click)="closeTrackModal()" aria-label="Close">✕</button>
        </div>
        <div class="acm-body" style="padding-bottom: 20px;">
            <div *ngFor="let signer of trackDoc?.signers; let i = index" class="track-signer-row"
                [class.track-signer-row--last]="i === trackDoc?.signers?.length - 1">
                <div class="track-signer-row__avatar">
                    {{ signer?.email?.charAt(0)?.toUpperCase() || '?' }}
                </div>
                <div class="track-signer-row__info">
                    <span class="track-signer-row__email">{{ signer?.email }}</span>
                    <span class="track-signer-row__date" *ngIf="signer?.signedAt">
                        Signed {{ signer?.signedAt | date: 'dd MMM yy, hh:mm a' }}
                    </span>
                </div>
                <span class="track-signer-row__badge"
                    [class.track-signer-row__badge--signed]="signer?.status === 'signed' || signer?.signedAt"
                    [class.track-signer-row__badge--pending]="signer?.status === 'pending' && !signer?.signedAt">
                    {{ (signer?.status === 'signed' || signer?.signedAt) ? 'Signed' : 'Pending' }}
                </span>
            </div>
            <div *ngIf="!trackDoc?.signers?.length" class="text-sm text-gray-400 text-center py-4">
                No signers found.
            </div>
        </div>
    </div>
</div>
<ng-template #documentModal let-modal>
    <div class="modal-header popupHeader">
        <h6>View Document</h6>
        <img (click)="closeDocumentModal()" class="usersFilter__crossIcon cursor-pointer"
            src="../../../assets/images/user-management/Cross.svg" alt="close" />
    </div>
    <div class="modal-body barcode-preview-modal p-0">
        <iframe *ngIf="selectedDocumentUrl" [src]="selectedDocumentUrl" width="100%"
            class="h-[70vh] md:h-[600px] block border-0" title="Document-Preview"></iframe>
    </div>
</ng-template>